module.exports = "<router-outlet></router-outlet>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/no-menu/no-menu.component.html
// module id = ./src/app/no-menu/no-menu.component.html
// module chunks = main